function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0l2.245 6.91h7.266l-5.878 4.27 2.245 6.91L10 13.82l-5.878 4.27 2.245-6.91L.49 6.91h7.266L10 0z",
  fill: "#EA7927"
});

function SvgReviewStarOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5OTcgMEwxMi4yNDUxIDYuOTA5ODNIMTkuNTEwNUwxMy42MzI3IDExLjE4MDNMMTUuODc3OCAxOC4wOTAyTDkuOTk5OTcgMTMuODE5N0w0LjEyMjEyIDE4LjA5MDJMNi4zNjcyNiAxMS4xODAzTDAuNDg5NDA1IDYuOTA5ODNINy43NTQ4M0w5Ljk5OTk3IDBaIiBmaWxsPSIjRUE3OTI3Ii8+Cjwvc3ZnPgo=";
export { SvgReviewStarOrange as ReactComponent };